import useQueryParams from 'components/hooks/useQueryParams';
import { useEffect, useMemo } from 'react';
import { isSensorSupportScopesValidations } from './scopes-validations.utils';

export const WITH_SCOPES_VALIDATIONS_QS = 'withScopesValidations';

const useScopesValidationsModalHandler = sensor => {
  const { useQueryParam, updateQueryParam } = useQueryParams();
  const isSupported = useMemo(
    () => isSensorSupportScopesValidations(sensor),
    [sensor]
  );

  const withScopeValidationsQs = useQueryParam(WITH_SCOPES_VALIDATIONS_QS);

  const closeModal = () => updateQueryParam(WITH_SCOPES_VALIDATIONS_QS, null);
  const openModal = () =>
    isSupported && updateQueryParam(WITH_SCOPES_VALIDATIONS_QS, true);
  const isOpen = !!withScopeValidationsQs && isSupported;

  useEffect(() => {
    if (withScopeValidationsQs && !isSupported) {
      closeModal();
    }
  }, [withScopeValidationsQs, isSupported]);

  return { isOpen, closeModal, openModal };
};

export default useScopesValidationsModalHandler;
